import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import useDebounce from '../../../../hooks/useDebounce';

import { useDispatch } from 'react-redux';
import { siteManagement } from '../../../../redux/actions';
import AddEntityDialog from '../../../dialogs/addEntityDialog';
import { Link } from 'react-router';

const CompetitorDetails = () => {
	const [entities, setEntities] = useState();
	const [searchKeyword, setSearchKeyword] = useState('');
	const debouncedSearchKeyword = useDebounce(searchKeyword);
	const [dialog, setDialog] = useState();

	const dispatch = useDispatch();

	const refreshEntities = useCallback(() => {
		dispatch(
			siteManagement(undefined, 'requestType=getEntity', true, entitiesResponse => {
				setEntities(entitiesResponse.responseObject || []);
			})
		);
	}, []);

	useEffect(() => {
		refreshEntities();
	}, [refreshEntities]);

	const handleSearchKeywordChange = e => {
		setSearchKeyword(e.target.value);
	};

	const closeDialog = () => {
		setDialog(null);
	};

	const showDialog = id => {
		switch (id) {
			case 'addEntityDialog':
				setDialog({
					id
				});
		}
	};

	const handleAddEntity = formData => {
		dispatch(
			siteManagement(formData, 'requestType=updateEntity', true, () => {
				closeDialog();
				refreshEntities();
			})
		);
	};

	const toggleStatus = entity => {
		dispatch(
			siteManagement({ ...entity, status: entity.status === 'BLOCKED' ? 'UNBLOCKED' : 'BLOCKED' }, 'requestType=updateEntity', true, updateEntityResponse => {
				if (updateEntityResponse.responseObject) {
					setEntities(prevEntities => prevEntities.map(prevEntity => (prevEntity.taxId === entity.taxId ? updateEntityResponse.responseObject : prevEntity)));
				}
			})
		);
	};

	const filteredEntities = useMemo(
		() =>
			entities
				? (debouncedSearchKeyword.trim()
						? entities.filter(entity => entity.taxId.includes(debouncedSearchKeyword) || entity.entityName.toLowerCase().includes(debouncedSearchKeyword.toLowerCase()))
						: entities
				  ).sort((a, b) => (a.entityName || '').toLowerCase().localeCompare((b.entityName || '').toLowerCase()))
				: entities,
		[entities, debouncedSearchKeyword]
	);

	return (
		<React.Fragment>
			<div>
				<div className="push">
					<h1 className="pageTitle">Competitor Details</h1>
				</div>
				<p className="flex items-center justify-between">
					<Link to="/siteManagement">Back to Site Management</Link>
				</p>
				<div className={`flex items-center${entities && entities.length > 0 ? ' justify-between' : ' justify-end'}`}>
					{entities && entities.length > 0 && <input type="text" placeholder="Filter by Tax ID or Entity" value={searchKeyword} onChange={handleSearchKeywordChange} />}
					<button onClick={showDialog.bind(this, 'addEntityDialog')}>Add Entity</button>
				</div>
				<section>
					{filteredEntities &&
						(filteredEntities.length > 0 ? (
							<React.Fragment>
								<div className="d-block d-sm-none">
									{filteredEntities.map(entity => (
										<div key={entity.taxId} className="p-2 border rounded" style={{ marginTop: '1rem' }}>
											<dl className="d-flex justify-content-between border-bottom">
												<dt>Tax ID</dt>
												<dd>{entity.taxId}</dd>
											</dl>
											<dl className="d-flex justify-content-between border-bottom">
												<dt>Entity Name</dt>
												<dd>{entity.entityName}</dd>
											</dl>
											<dl className="d-flex justify-content-between border-bottom">
												<dt>Notes</dt>
												<dd>{entity.notes}</dd>
											</dl>
											<dl className="d-flex justify-content-between border-bottom">
												<dt>Date Added</dt>
												<dd>{moment(entity.createdDate).format('MM/DD/YYYY')}</dd>
											</dl>
											<dl className="d-flex justify-content-between border-bottom">
												<dt>Requestor</dt>
												<dd>{entity.requestor}</dd>
											</dl>
											<dl className="d-flex justify-content-between border-bottom">
												<dt>Last Updated</dt>
												<dd>{moment(entity.lastUpdatedDate).format('MM/DD/YYYY')}</dd>
											</dl>
											<dl className="d-flex justify-content-between border-bottom">
												<dt>Updated By</dt>
												<dd>{entity.updatedBy}</dd>
											</dl>
											<dl className="d-flex justify-content-between border-bottom">
												<dt>Status</dt>
												<dd>
													<button
														className={`small fullWidth ${entity.status === 'BLOCKED' ? 'orangeButton' : 'blueButton'}`}
														onClick={toggleStatus.bind(this, entity)}
													>
														{entity.status}
													</button>
												</dd>
											</dl>
										</div>
									))}
								</div>
								<div className="d-none d-sm-block">
									<table className="dataTable fullWidth">
										<thead>
											<tr>
												<th>Tax ID</th>
												<th>Entity Name</th>
												<th>Notes</th>
												<th>Date Added</th>
												<th>Requestor</th>
												<th>Last Updated</th>
												<th>Updated By</th>
												<th>Status</th>
											</tr>
										</thead>
										<tbody>
											{filteredEntities.map(entity => (
												<tr key={entity.taxId}>
													<td>{entity.taxId}</td>
													<td>{entity.entityName}</td>
													<td>{entity.notes}</td>
													<td>{moment(entity.createdDate).format('MM/DD/YYYY')}</td>
													<td>{entity.requestor}</td>
													<td>{moment(entity.lastUpdatedDate).format('MM/DD/YYYY')}</td>
													<td>{entity.updatedBy}</td>
													<td>
														<button
															className={`small fullWidth ${entity.status === 'BLOCKED' ? 'orangeButton' : 'blueButton'}`}
															onClick={toggleStatus.bind(this, entity)}
														>
															{entity.status}
														</button>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</React.Fragment>
						) : (
							<p className="text-center" style={{ marginTop: '2rem' }}>
								No records found
							</p>
						))}
				</section>
			</div>
			{dialog && dialog.id === 'addEntityDialog' && <AddEntityDialog onClose={closeDialog} onSubmit={handleAddEntity} />}
		</React.Fragment>
	);
};

export default CompetitorDetails;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/Dpm/competitorDetails.jsx